import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.03 16.876a.75.75 0 0 1 .72.779c-.09 2.255-1.97 4.154-4.453 4.094-.577-.014-1.255-.206-2.319-.506l-.13-.037c-2.924-.825-5.792-2.3-6.474-5.78-.124-.63-.124-1.327-.124-2.495v-1.862c0-1.168 0-1.864.124-2.495.682-3.48 3.55-4.955 6.474-5.78l.13-.037c1.064-.3 1.742-.492 2.32-.506 2.483-.06 4.362 1.84 4.451 4.094a.75.75 0 1 1-1.498.06c-.058-1.449-1.265-2.694-2.917-2.654-.362.009-.841.138-2.08.487-2.799.79-4.899 2.027-5.408 4.625-.093.47-.096 1.01-.096 2.3v1.674c0 1.29.003 1.83.096 2.3.51 2.598 2.61 3.836 5.409 4.625 1.238.35 1.717.478 2.079.487 1.652.04 2.859-1.205 2.917-2.654a.75.75 0 0 1 .779-.72",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.038 8.977a.75.75 0 0 1-.015 1.06 9 9 0 0 1-.72.597 26 26 0 0 0-.765.616H21a.75.75 0 0 1 0 1.5h-9.462l.007.006c.249.21.512.417.757.61l.057.045c.245.192.502.394.664.551a.75.75 0 1 1-1.046 1.076 9 9 0 0 0-.604-.495 27 27 0 0 1-.797-.643 7.4 7.4 0 0 1-.827-.797 2.7 2.7 0 0 1-.324-.46A1.4 1.4 0 0 1 9.25 12c0-.258.089-.48.175-.642.09-.168.206-.323.324-.461.234-.276.536-.551.826-.797.272-.23.556-.453.798-.643l.06-.047q.407-.318.544-.448a.75.75 0 0 1 1.06.015",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }